import { FormGroup } from '@angular/forms';
import { ControlMessages } from './control-messages';

export abstract class FormValidationComponent {
  abstract form: FormGroup;
  abstract formLabels: Record<string, string>;

  hasControlError(formControlName: string) {
    const control = this.form.get(formControlName);

    if (!control) {
      return false;
    }
    const { invalid, touched, dirty } = control;
    return invalid && (touched || dirty);
  }

  getControlErrorMessage(formControlName: string): string | null {
    const control = this.form.get(formControlName);

    if (!control || !control.errors || !this.hasControlError(formControlName)) {
      return null;
    }

    const message = ControlMessages.getErrorMessage(
      this.formLabels[formControlName],
      control,
      Object.keys(control.errors)[0] as string
    );

    return message ? Object.values(message)[0] : 'Campo inválido';
  }

  hasGroupError(): boolean {
    return this.form.errors && this.form.touched;
  }

  getGroupErrorMessage(): string | null {
    const errors = this.form.errors;

    if (!errors) {
      return null;
    }

    const errorKey = Object.keys(errors)[0];
    const rawFields = errors[errorKey]?.fields ?? [];

    const fieldLabels = Array.isArray(rawFields)
      ? rawFields.map((f) => this.formLabels[f] ?? f)
      : [];

    const message = ControlMessages.getErrorMessage(
      fieldLabels.length ? fieldLabels : 'Campo',
      this.form,
      errorKey
    );

    return message ? Object.values(message)[0] : 'Erro no formulário';
  }
}
